
import { Scale } from "lucide-react";
import { useState } from "react";
import { UnitConverterForm } from "./unit-converter/UnitConverterForm";

export function UnitConverter() {
  const [selectedMeasurementType, setSelectedMeasurementType] = useState("");

  return (
    <div className="w-full max-w-2xl mx-auto p-4 space-y-6">
      <div className="bg-gradient-to-br from-white/60 to-white/40 backdrop-blur-sm rounded-lg 
                    shadow-lg p-8 border border-manuscript-primary/10 
                    transition-all duration-300 hover:shadow-xl animate-scale-in">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="h-px w-12 bg-gradient-to-r from-transparent via-manuscript-secondary/60 to-transparent"></div>
          <span className="text-2xl font-cinzel text-manuscript-primary">Convert</span>
          <Scale className="w-6 h-6 text-manuscript-secondary" />
          <span className="text-2xl font-cinzel text-manuscript-primary">Units</span>
          <div className="h-px w-12 bg-gradient-to-r from-transparent via-manuscript-secondary/60 to-transparent"></div>
        </div>
        
        <UnitConverterForm onMeasurementTypeChange={setSelectedMeasurementType} />
      </div>
    </div>
  );
}
